import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"
import CustomSelect from "../../../common/interactive/CustomSelect"
import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { surgicallreadyexistsOnOtherWorkerComps } from "../../../../lib/script"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { frontendOptions } from "../../../../lib/systemData"

import classes from './WorkersCompDepartments.module.css'

export default function WorkersCompDrawerSurgicalItem({surgicalItem, departmentId, workerCompData}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [workersCompDepartmentSurgicalItem, setWorkersCompDepartmentSurgicalItem] = useState(null)
    const [step4, setStep4] = useState(null)
    const [step5, setStep5] = useState(null)
    const [finalStep, setFinalStep] = useState(null)
    const [itemIsDisabled, setItemIsDisabled] = useState(false)

    useEffect(() => {
        if (workerCompData.worker_comp_departments) {
            
            let specificDepartment = workerCompData.worker_comp_departments.find(item => item.department_id == departmentId)
    
            if (specificDepartment && specificDepartment.surgeries && specificDepartment.surgeries.length > 0 && specificDepartment.surgeries.find(item => item.surgery_id == surgicalItem.id)) {      
                let foundSurgery = specificDepartment.surgeries.find(item => item.surgery_id == surgicalItem.id)
                setWorkersCompDepartmentSurgicalItem(foundSurgery)

                if (foundSurgery.steps && foundSurgery.steps.length > 0) {
                    foundSurgery.steps.forEach(element => {
                        if (element.step == 4) {
                            setStep4(element)
                        }
                        if (element.step == 5) {
                            setStep5(element)
                        }
                        if (element.step == 15) {
                            setFinalStep(element)
                        }
                    });
                }

                
            } else {
                setWorkersCompDepartmentSurgicalItem(null)
            }
        }

        setItemIsDisabled(surgicallreadyexistsOnOtherWorkerComps(workerCompData.id, activeCase, departmentId, surgicalItem.id))
        
        
    }, [activeCase, workerCompData.worker_comp_departments, departmentId])

    async function updateHandler(data) {
        // first need to verify that the department exists!!!! If not, need to create one the properly update the services in real time
        
        let specificDepartment = workerCompData.worker_comp_departments.find(item => item.department_id == departmentId)

        if (!specificDepartment) { // department does not exists, creating department....
            let departmentreqBody = {
                type: 'case_worker_comp_departments',
                type_id: data.identifier.type_id, // same as below
                fields: {
                    department_id: departmentId,
                }
            }
    
            let update = await caseQuickUpdate(userToken, activeCase.case.id, departmentreqBody)
    
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {            
    
                let dispatchObj = {
                    folder: data.identifier.folder,
                    itemId: data.identifier.type_id,
                    departmentId: data.identifier.department_id,
                    data: update
                }
        
        
                dispatch(caseActions.setDepartmentOnWorkersComp(dispatchObj))
            } 
        }

        // then continue with the rest of the logic.
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                department_id: data.identifier.department_id,
                surgery_id: data.identifier.surgery_id,
                step: data.identifier.step,
                [data.identifier.field] : data.data.value,
            }
        }

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {  
            let dispatchObj = {
                folder: data.identifier.folder,
                itemId: data.identifier.type_id,
                departmentId: data.identifier.department_id,
                surgicalId: data.identifier.surgery_id,
                data: update
            }    
    
            dispatch(caseActions.setSurgicalOnWorkersComp(dispatchObj))
        } 
    }


    return <React.Fragment >
        <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}>                        
            <td rowSpan={3}>{surgicalItem.rse_area}</td>
            <td>#4 Surgery Evaluation</td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step4?.request_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'request_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 4}}/>
            </td>
            <td className="table-cell-no-padding">
                <CustomSelect optionsData={frontendOptions()?.statusOptions} preSelectedValue={step4?.status_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'status_id', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 4}} sameSizeAsContainer={true}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step4?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 4}}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step4?.auth_exp_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_exp_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 4}}/>
            </td>
            <td rowSpan={3}>
                <CheckboxCell checked={workersCompDepartmentSurgicalItem?.is_outside_clinic} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgeries', field: 'is_outside_clinic', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps'}} setStyle={'centered'}/>
            </td>
            <td rowSpan={3}>
                
            </td>
            <td rowSpan={3}></td>
        </tr>
        <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}> 
            <td>#5 Performing Surgeon Evaluation</td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step5?.request_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'request_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 5}}/>
            </td>
            <td className="table-cell-no-padding">
                <CustomSelect optionsData={frontendOptions()?.statusOptions} preSelectedValue={step5?.status_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'status_id', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 5}} sameSizeAsContainer={true}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step5?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 5}}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={step5?.auth_exp_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_exp_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 5}}/>
            </td>
        
        </tr>
        <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}>
            <td># Sugery Insurance Authorization Obtained</td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={finalStep?.request_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'request_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 15}}/>
            </td>
            <td className="table-cell-no-padding">
                <CustomSelect optionsData={frontendOptions()?.statusOptions} preSelectedValue={finalStep?.status_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'status_id', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 15}} sameSizeAsContainer={true}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={finalStep?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 15}}/>
            </td>
            <td>
                <DatepickerWithLabel textRight={true} defaultDate={finalStep?.auth_exp_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_surgery_steps', field: 'auth_exp_date', type_id: workerCompData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'worker_comps', step: 15}}/>
            </td>

        </tr>
    </React.Fragment>
}